<div class="flex flex-1 rounded-md border p-2">
  <div class="flex-1 grid grid-cols-{{ item.config?.cols || '2' }} gap-4">
    @for (cell of item.config?.items; track cell) {
      <div
        class="group flex cursor-pointer flex-col gap-1 border-b border-slate-300 transition-colors hover:border-slate-500"
      >
        <span
          class="text-sm text-slate-500 transition-colors group-hover:text-slate-700"
          >{{ cell.title }}</span
        >
        <span
          class="text-base font-medium text-slate-700 transition-colors group-hover:text-slate-900"
          >{{
            cell.property | formPropertyBind: dataSource : cell.dataType
          }}</span
        >
      </div>
    }
  </div>
</div>
